import { formatDate } from '@btime/helpers'
import moment from 'moment'

export const clearName = string => (string ? string.replace(/\s/g, '').toLowerCase() : string)

export const getPlaceNames = string => {
  const index = string.indexOf(' ')
  const placeCode = string.substring(0, index)
  const placeName = string.substring(index + 1)
  return {
    placeCode: placeCode ? placeCode.trim() : 'N/A',
    placeName: placeName ? placeName.trim() : 'N/A'
  }
}

export const getUserNames = serviceOrder => {
  const { user } = serviceOrder
  const registryNumber = user.fieldValues.find(
    fieldValue => fieldValue.field && fieldValue.field.name === 'Número do Registro'
  )
  return {
    userName: user.name,
    userCode: registryNumber ? registryNumber.value : 'N/A'
  }
}

export const getReplyValue = reply => {
  if (!reply) {
    return 'N/A'
  }
  if (reply.question.type.name === 'sign') {
    return reply.value.name
  }
  return reply.value
}

export const getAddressValue = serviceOrder => {
  if (!serviceOrder.address) {
    const fieldFound = serviceOrder.place.fieldValues.find(fieldValue => fieldValue.field.name === 'Endereço')
    if (!fieldFound) {
      return '**N/A**'
    }
    return fieldFound.value.search
  }

  return serviceOrder.address.search
}

export const totalEmployees = replies => {
  const repliesFound = replies.filter(
    reply => clearName(reply.question.name) === clearName('Quantos funcionários possui nesse cargo?')
  )
  const total = repliesFound.reduce((total, current) => {
    return (total += current.value)
  }, 0)

  return total
}

export const filterRepliesByQuestionName = (replies, name) => {
  return replies.filter(reply => clearName(reply.question.name).includes(clearName(name)))
}

export const findReplyByQuestionName = (replies, name) => {
  return replies.find(reply => clearName(reply.question.name).includes(clearName(name)))
}

export const getReplyFromMultipleChoice = (respostas, name) => {
  if (!respostas) {
    return { value: 'N/A' }
  }
  return respostas.find(reply => clearName(reply.name).includes(clearName(name)))
}

export const filterRepliesByParentReference = (replies, reference) => {
  return replies.filter(
    reply => reply.question.parentReference && reply.question.parentReference.indexOf(reference) === 0
  )
}

export const findReplyByReference = (replies, reference) => {
  return replies.find(reply => reply.question.reference === reference)
}

export const getJobDescription = questionName => {
  switch (clearName(questionName)) {
    case clearName('Área de Atendimento - Tem Assistente de Relacionamento Empresas?'):
      return {
        setor: 'Atendimento',
        funcao: 'Assistente de Relacionamento Empresas',
        descricao:
          'Executar o atendimento telefônico ao cliente para entrada de solicitações, reclamações e ocorrências dos clientes, e redirecionamento das mesmas às áreas responsáveis para sua solução.'
      }

    case clearName('Área de Atendimento - Tem Gerente Negócios e Serviços I 6h?'):
      return {
        setor: 'Atendimento',
        funcao: 'Gerente Negócios e Serviços I 6h',
        descricao:
          'Apoio na gestão da carteira compartilhada e, em alguns locais, efetua o atendimento de clientes PJ E1 e Van Gogh GNS I em agências padrão, atividade de conquista, gestão e rentabilização da carteira compartilhada, potencializando a oferta de produtos e serviços. Atividades: Gestão da carteira compartilhada, Primeiro Atendimento, Organização e Rentabilização de Fluxo e Disponibilidade da Loja.'
      }

    case clearName('Área de Atendimento - Tem Gerente de  Atendimento I?'):
      return {
        setor: 'Atendimento',
        funcao: 'Gerente de  Atendimento I',
        descricao:
          'O Gerente de Atendimento (GA) tem como atribuição fundamental gerenciar a Equipe de Atendimento, planejando as atividades de processamento das operações e de atendimento, assegurando a qualidade do serviço prestado ao cliente, representando o Banco perante terceiros. Deve garantir o cumprimento dos normativos e regulamentações vigentes e o pleno funcionamento e atendimento da unidade, inclusive sob os aspectos de segurança física e patrimonial, visando garantir a satisfação de clientes e qualidade operacional, bem como incentivar a equipe a aproveitar cada oportunidade de atendimento para oferta de produtos e serviços do Mais certo.'
      }

    case clearName('Área de Atendimento - Tem Gestor A+?'):
      return {
        setor: 'Atendimento',
        funcao: 'Gestor A+',
        descricao:
          'Assegurar a implantação e manutenção do modelo de atendimento ao cliente nas agências, por meio de análises dos resultados e índices de qualidade, a fim de propor ações de melhoria ao modelo de atendimento.'
      }

    case clearName('Área de Atendimento - Tem Caixa?'):
      return {
        setor: 'Atendimento',
        funcao: 'Caixa',
        descricao:
          'Como caixa você deverá realizar as transações dos clientes com segurança e eficácia, prezando pela qualidade no atendimento e na parte operacional, de acordo com normas e procedimentos estabelecidos pelo banco, visualizando oportunidades para ofertar dos produtos foco e do Mais CERTO.'
      }

    case clearName('Área de Atendimento - Tem Gestor Atendimento?'):
      return {
        setor: 'Atendimento',
        funcao: 'Gestor Atendimento',
        descricao:
          'Atende fornecedores e clientes, fornecendo e recebendo informações sobre produtos e serviços; trata de documentos variados, cumprindo todo o procedimento necessário referente aos mesmos; prepara relatórios e planilhas; executa serviços.'
      }

    case clearName('Área Comercial - Tem Gerente Geral Agência?'):
      return {
        setor: 'Comercial',
        funcao: 'Gerente Geral Agência',
        descricao:
          'O Gerente Geral tem o papel fundamental de gerenciar a unidade de negócio (Agência, PAB, Núcleo), garantindo que todas as ações sejam direcionadas para o aproveitamento das oportunidades comerciais, cumprindo os procedimentos e níveis de serviço na execução diária das atividades e no acompanhamento dos Gerentes nas visitas.'
      }

    case clearName('Área Comercial - Tem Gerente Negócios e Serviços II 8h?'):
      return {
        setor: 'Comercial',
        funcao: 'Gerente Negócios e Serviços II 8h',
        descricao:
          'Responsabilidades e funções comercial e administrativa, para melhor atendimento e geração de negócios aproveitando o fluxo das agências. Faz gestão da carteira compartilhada e, em alguns locais, efetua o atendimento de clientes PJ E1 e Van Gogh. Faz gestão do numerário e tem responsabilidade sobre chave e segredo da agência e do cofre. Atividades: Gestão da carteira compartilhada, Primeiro Atendimento, Organização e Rentabilização de Fluxo e Disponibilidade da Loja.'
      }

    case clearName('Área Comercial - Tem Gerente Relacionamento Van Gogh?'):
      return {
        setor: 'Comercial',
        funcao: 'Gerente Relacionamento Van Gogh',
        descricao:
          'O Gerente Van Gogh tem o papel de conquistar novos clientes no segmento, realizar a venda de produtos e/ou serviços, prezando pela qualidade de acordo com normas e procedimentos estabelecidos pelo banco e órgãos reguladores.'
      }

    case clearName('Área Comercial - Tem Gerente Relacionamento Empresas I?'):
      return {
        setor: 'Comercial',
        funcao: 'Gerente Relacionamento Empresas I',
        descricao:
          'O Gerente Empresas I tem o papel de conquistar novos clientes com o objetivos de aumentar sua carteira junto ao mercado, por meio da oferta e venda de produtos e/ou serviços para clientes com faturamento de até 1 milhão, zelando pelo atendimento personalizado e com qualidade.'
      }

    case clearName('Área Comercial - Tem Gerente Relacionamento Empresas II?'):
      return {
        setor: 'Comercial',
        funcao: 'Gerente Relacionamento Empresas II',
        descricao:
          'Conquistar novos clientes, visando aumentar sua carteira junto ao mercado alvo, através da oferta e venda de produtos e/ou serviços para clientes com faturamento de 80 MM até 200 MM, zelando pelo atendimento personalizado e com qualidade.'
      }

    case clearName('Área Comercial - Tem Gerente Relacionamento Empresas III?'):
      return {
        setor: 'Comercial',
        funcao: 'Gerente Relacionamento Empresas III',
        descricao:
          'O Gerente Empresas III tem o papel de conquistar novos clientes com o objetivos de aumentar sua carteira junto ao mercado, por meio da oferta e venda de produtos e/ou serviços para clientes com faturamento de 10 milhões a 80 milhões , zelando pelo atendimento personalizado e com qualidade.'
      }

    case clearName('Área Comercial - Tem Gte Relac Empresas IV?'):
      return {
        setor: 'Comercial',
        funcao: 'Gte Relac Empresas IV',
        descricao:
          'Conquistar novos clientes, visando aumentar sua carteira junto ao mercado alvo, através da oferta e venda de produtos e/ou serviços para clientes com faturamento de 80 MM até 200 MM, zelando pelo atendimento personalizado e com qualidade.'
      }

    case clearName('Área de Atendimento - Tem Assistente Select J6?'):
      return {
        setor: 'Atendimento',
        funcao: 'Assistente Select J6',
        descricao:
          'Apoiar no atendimento consultivo aos clientes do segmento Select, visando responder dúvidas e/ou questionamentos sobre produtos e serviços do Banco. Ofertar produtos e serviços quando for identificada a oportunidade.'
      }

    case clearName('Área de Atendimento - Tem Caixa Select?'):
      return {
        setor: 'Atendimento',
        funcao: 'Caixa Select',
        descricao:
          'Como caixa você deverá realizar as transações dos clientes com segurança e eficácia, prezando pela qualidade no atendimento e na parte operacional, de acordo com normas e procedimentos estabelecidos pelo banco, visualizando oportunidades para ofertar dos produtos foco e do Mais CERTO.'
      }

    case clearName('Área de Atendimento - Tem Supervisor Atendimento Select?'):
      return {
        setor: 'Atendimento',
        funcao: 'Supervisor Relacionamento Select',
        descricao:
          'Supervisionar e desenvolver equipe de Assistentes que prestam atendimento aos clientes do segmento Select.'
      }

    case clearName('Área de Atendimento - Tem Coordernador Atendimento Select?'):
      return {
        setor: 'Atendimento',
        funcao: 'Coordernador Atendimento Select',
        descricao:
          'O coordenador de atendimento deve coordenar as atividades de atendimento aos clientes e a formalização das operações na agência, orientando funcionários, precedendo à abertura e o fechamento físico do caixa e assegurando os lançamentos e registros das movimentações efetuadas garantindo a correta aplicação das normas e procedimentos estabelecidos pelo Banco e prezando pela qualidade no Atendimento e operacional, visualizando oportunidades de negócios dos produtos foco, além de disseminar a cultura de servir com foco na satisfação do cliente.'
      }

    case clearName('Área Comercial - Tem Gerente Relacionamento Select?'):
      return {
        setor: 'Comercial',
        funcao: 'Gerente Relacionamento Select',
        descricao:
          'O Gerente Select tem o papel de conquistar, criar e manter relacionamento com Clientes alta renda, oferecendo soluções financeiras e zelando pelo atendimento e a qualidade dos serviços prestados pelo Banco.'
      }

    case clearName('Área Comercial - Tem Gte Direct Select?'):
      return {
        setor: 'Comercial',
        funcao: 'Gte Direct Select',
        descricao:
          'O Gerente Digital Select tem o papel de fazer a gestão remota de clientes PF Alta Renda, realizando a venda de produtos e/ou serviços, prezando pela qualidade de acordo com normas e procedimentos estabelecidos pelo banco e órgãos reguladores.'
      }

    case clearName('Área Comercial - Tem Gte Direct Select Líder?'):
      return {
        setor: 'Comercial',
        funcao: 'Gte Direct Select Líder',
        descricao: `Backup do GG durante sua ausência; Ponto de referência para dúvidas dos GRs, será responsável pela gestão do account load dos Gte Digitais (quando houver necessidade fará o split da carteira), coordenará o giro da carteira, alinhará novas estratégias, apoiara a gestão dos planos comerciais e de qualidade. Terá uma carteira de clientes reduzida (aproximadamente 1/2 do GR).Entender os desafios da Agência, apoiar as estratégias comerciais, acompanhar o cumprimento dos planos comerciais, produtividade e qualidade. Garantir a prática dos Valores da Organização e Governança do Digital, mantendo-se atualizado sobre produtos, fluxos, normas internas, processos e políticas do banco, assegurando sua correta divulgação para os GR's; Atuação direta com os clientes, prestando todo o atendimento necessário e oferta de produtos.`
      }

    case clearName('Área Comercial - Tem Gte Relac Select Lider?'):
      return {
        setor: 'Comercial',
        funcao: 'Gte Relac Select Lider',
        descricao:
          'Responsável por gerenciar uma carteira de clientes própria reduzida , além de atuar como gestor e formador do time de gerentes de select da agência Store in Store Select (Select High, Select e Gerente de Negócios e Serviços), com o objetivo de aumentar a carteira bem como fomentar mais negócios, alavancando a produtividade da equipe, reportando-se diretamente ao GG da unidade. Coordenará a execução do giro da carteira dos GRs, alinhará novas estratégias, apoiara a gestão dos planos comerciais e de qualidade.'
      }

    case clearName('Área de Atendimento - Tem Gte Atendimento I (Agro)?'):
      return {
        setor: 'Comercial',
        funcao: 'Gte Atendimento I (Agro)',
        descricao:
          'Gerenciar equipe, preferencialmente em agências de pequeno porte, planejando as atividades de processamento das operações e de atendimento, assegurando a qualidade do serviço prestado ao cliente dentro das opções existentes nos pontos de venda.'
      }

    case clearName('Área Comercial - Tem Gte Coml Agro I?'):
      return {
        setor: 'Comercial',
        funcao: 'Gte Coml Agro I',
        descricao:
          'Preparar e executar a negociação e formalização de produtos estruturados. Gerenciar carteira de clientes Agronegócios através da gestão da oferta de produtos, visitas nos imóveis para coleta de informações e documentações de crédito ou específicas requeridas pelo produto. Fazer visitas de manutenção e acompanhamento do relacionamento e preventivas de crédito, quanto a gestão da qualidade da carteira. Interagir com a agência onde o cliente detém a conta para andamento dos processos e utilização dos limites de ativos ou operações pontuais.'
      }

    case clearName('Área Comercial - Tem Gte Agronegocios II?'):
      return {
        setor: 'Comercial',
        funcao: 'Gte Agronegocios II',
        descricao:
          'Controlar e executar a negociação e formalização de produtos estruturados, serviços tradicionais e específicos comercializados pela entidade de acordo às necessidades de determinados segmentos (emissões de renda fixa e variável, seguros, fusões, financiamento especializado, segmento universidades e governos etc.)'
      }

    case clearName('Área Comercial - Tem Supte Coml Agronegocios?'):
      return {
        setor: 'Comercial',
        funcao: 'Supte Coml Agronegocios',
        descricao:
          'Liderar, estabelecer a negociação e formalização de produtos estruturados, serviços tradicionais e específicos comercializados pela entidade de acordo às necessidades de determinados segmentos (emissões de renda fixa e variável, seguros, fusões, financiamento especializado, segmento universidades e governos etc.)'
      }

    case clearName('Área Comercial - Tem Gte Coml Agro II?'):
      return {
        setor: 'Comercial',
        funcao: 'Gte Coml Agro II',
        descricao:
          'Controlar e executar a negociação e formalização de produtos. Gerenciar carteira de clientes Agronegócios através da gestão da oferta de produtos, visitas nos imóveis para coleta de informações e documentações de crédito ou específicas requeridas pelo produto. Fazer visitas de manutenção e acompanhamento do relacionamento e preventivas de crédito, quanto a gestão da qualidade da carteira. Interagir com a agência onde o cliente detém a conta para andamento dos processos e utilização dos limites de ativos ou operações pontuais.'
      }

    case clearName('Área Comercial - Tem Gte Coml Agro III?'):
      return {
        setor: 'Comercial',
        funcao: 'Gte Coml Agro III',
        descricao:
          'Analisar, elaborar e controlar a negociação e formalização de produtos. Gerenciar carteira de clientes Agronegócios através da gestão da oferta de produtos, visitas nos imóveis para coleta de informações e documentações de crédito ou específicas requeridas pelo produto. Fazer visitas de manutenção e acompanhamento do relacionamento e preventivas de crédito, quanto a gestão da qualidade da carteira. Interagir com a agência onde o cliente detém a conta para andamento dos processos e utilização dos limites de ativos ou operações pontuais.'
      }

    case clearName('Área Comercial - Tem Agente Prospera?'):
      return {
        setor: 'Comercial',
        funcao: 'Agente Prospera',
        descricao:
          'Gestão de carteira e prospecção de clientes, Trabalhar de acordo com metodologia do segmento; Garantir a renovação dos contratos; Garantir aproximação e satisfação do cliente; Controle da inadimplência da carteira; Cobrança preventiva; Fazer acordos; Identificação e ação nas parcerias em potencial.'
      }

    case clearName('Área Comercial - Tem Assist Regional Prospera?'):
      return {
        setor: 'Comercial',
        funcao: 'Assist Regional Prospera',
        descricao:
          'Suporte na gestão e acompanhamento da Regional em relação a produção, inadimplência e crescimento de carteira, além de indicadores financeiros. Realização do pós venda com foco na identificação de falhas metodológicas e qualidade da carteira de crédito. Apoio na gestão da carteira de atraso, acompanhando os assistentes das filiais e fazendo alinhamento com os agentes de crédito. Realização de cobranças por telefone e efetivação de acordos e revitalizações. Ser back up dos assistentes nas filiais.'
      }

    case clearName('Área Comercial - Tem Superv Prospera?'):
      return {
        setor: 'Comercial',
        funcao: 'Superv Prospera',
        descricao:
          'Crescer carteira de crédito, resultados e rentabilidade da sua filial; Identificar parcerias e oportunidades de novos negócios; Garantir oferta de produtos adequada ao cliente (venda); Controlar da inadimplência da filial e cobrar maiores casos; Ter excelência na qualidade operacional da filial; Gestão de equipe de alta performance; Garantir que a equipe esteja capacitada à fazer sua função; Direcionar e dar constante feedback para equipe; Visitar em conjunto com equipe, fazendo planos de ação e eventuais correções de rota.'
      }

    case clearName('Área Comercial - Tem Assistente Coml Prospera?'):
      return {
        setor: 'Comercial',
        funcao: 'Assistente Coml Prospera',
        descricao:
          'Dar suporte direto na gestão e acompanhamento da filial; Controlar a produção, inadimplência e crescimento de carteira; Gestão de indicadores financeiros; Garantir qualidade operacional; Formalização das operações; Gestão de contratos; Gestão de reclamações; Gestão de inadimplência da filial; Gestão de cobrança.'
      }

    case clearName('Área Comercial - Tem Gte Regional Prospera?'):
      return {
        setor: 'Comercial',
        funcao: 'Gte Regional Prospera',
        descricao:
          'Gerenciar projetos e equipes e Implementar plano de trabalho o processo de venda (prospecção e assessoramento) e formalização dos produtos de ativo e passivo comercializados nos pontos de venda.'
      }
    case clearName('Área Comercial - Tem Agente de crédito?'):
      return {
        setor: 'Comercial',
        funcao: 'Agente de crédito',
        descricao:
          'Executar o processo de venda (prospecção e assessoramento) e formalização dos produtos de ativo e passivo comercializados nos pontos de venda.'
      }
    case clearName('Área Comercial - Tem Agente de Microcrédito?'):
      return {
        setor: 'Comercial',
        funcao: 'Agente de Microcrédito',
        descricao:
          'Gestão de carteira e prospecção de clientes, Trabalhar de acordo com metodologia do segmento; Garantir a renovação dos contratos; Garantir aproximação e satisfação do cliente; Controle da inadimplência da carteira; Cobrança preventiva; Fazer acordos; Identificação e ação nas parcerias em potencial.'
      }

    default:
      return null
  }
}

export const max = (replies, questionName) => {
  let max = 0
  replies.forEach(reply => {
    if (clearName(reply.question.name) === clearName(questionName) && reply.value > max) {
      max = reply.value
    }
  })
  return max
}

export const findParentReply = (replies, reply) => {
  return replies.find(r => r.question.reference === reply.question.parentReference)
}

export const getReplyValueFieldOrDefault = (reply, field = 'value', defaultValue = '') => {
  if (!reply || reply[field] === undefined) {
    return defaultValue
  }
  return reply[field]
}

export const getImages = (reply, index = -1) => {
  if (index >= 0) {
    return [reply.value[index].src]
  }
  return reply.value ? reply.value : reply
}

export const getDate = reply => {
  if (!reply) {
    return 'Não informada'
  }
  if (typeof reply === 'string') {
    return formatDate('DD/MM/YYYY', reply)
  }
  return formatDate('DD/MM/YYYY', reply.value)
}

export const dateAdd12Months = dateAsString => {
  const newDate = moment(dateAsString).add(12, 'M')
  return formatDate('DD/MM/YYYY', newDate)
}

export const genCalibrationValidity = (replies, calibrationDateQuestion, calibrationExpirationQuestion) => {
  const calibrationDate = findReplyByQuestionName(replies, calibrationDateQuestion)
  const expirationDate = findReplyByQuestionName(replies, calibrationExpirationQuestion)
  const validadeCalibracao = expirationDate ? getDate(expirationDate) : dateAdd12Months(calibrationDate.value)
  return validadeCalibracao
}

export const formatIssueDate = date => {
  const month = moment(date).format('MMM').toUpperCase()
  const currentYear = moment(date).format('YYYY').toUpperCase()
  const expiryYear = moment(date).add(1, 'y').format('YYYY').toUpperCase()
  return {
    month,
    currentYear,
    expiryYear
  }
}

export const remapReplyChildren = replies => {
  const remap = {}
  replies.forEach(reply => {
    if (reply.question.parentReference) {
      if (!remap[reply.question.parentReference]) {
        remap[reply.question.parentReference] = []
      }
      remap[reply.question.parentReference].push(reply)
    } else {
      if (!remap[reply.question.reference]) {
        remap[reply.question.reference] = []
      }
      remap[reply.question.reference].push(reply)
    }
  })
  return remap
}

export const remapReplies = replies => {
  const result = { atendimento: [], comercial: [] }
  replies.forEach(reply => {
    if (reply.value) {
      const job = getJobDescription(reply.question.name)
      if (job) {
        const childrenReplies = filterRepliesByParentReference(replies, reply.question.reference)
        result[job.setor.toLowerCase()].push({
          ...job,
          reference: reply.question.reference,
          parentReference: reply.question.parentReference,
          ...(childrenReplies ? { childrenReplies } : {})
        })
      }
    }
  })
  return result
}

export const formatPercentNumber = number => {
  return Number(number.toFixed(2))
}

export const getConclusion = (percent, type) => {
  if (type === 'areaInterna') {
    return 'xxx'
  }

  if (percent >= 91 && type === 'mouse') {
    return `Os mouses de trabalho atendem de ${percent}% dos pontos de condições ergonômicas, ou seja, acessórios em
    condições ergonômicas excelentes.`
  }
  if (percent >= 71 && type === 'mouse') {
    return `Os mouses de trabalho atendem de ${percent}% dos pontos de condições ergonômicas, ou seja, acessórios em
    condições ergonômicas boas.`
  }
  if (percent >= 51 && type === 'mouse') {
    return `Os mouses de trabalho atendem de ${percent}% dos pontos de condições ergonômicas, ou seja, acessórios em
    condições ergonômicas razoáveis.`
  }
  if (percent >= 31 && type === 'mouse') {
    return `Os mouses de trabalho atendem de ${percent}% dos pontos de condições ergonômicas, ou seja, acessórios em
    condições ergonômicas ruins.`
  }
  if (percent < 31 && type === 'mouse') {
    return `Os mouses de trabalho atendem de ${percent}% dos pontos de condições ergonômicas, ou seja, acessórios em
    condições ergonômicas péssimas.`
  }

  if (percent >= 91 && type === 'teclado') {
    return `Os teclados de trabalho atendem de ${percent}% dos pontos de condições ergonômicas, ou seja, acessórios em
    condições ergonômicas excelentes.`
  }
  if (percent >= 71 && type === 'teclado') {
    return `Os teclados de trabalho atendem de ${percent}% dos pontos de condições ergonômicas, ou seja, acessórios em
    condições ergonômicas boas.`
  }
  if (percent >= 51 && type === 'teclado') {
    return `Os teclados de trabalho atendem de ${percent}% dos pontos de condições ergonômicas, ou seja, acessórios em
    condições ergonômicas razoáveis.`
  }
  if (percent >= 31 && type === 'teclado') {
    return `Os teclados de trabalho atendem de ${percent}% dos pontos de condições ergonômicas, ou seja, acessórios em
    condições ergonômicas ruins.`
  }
  if (percent < 31 && type === 'teclado') {
    return `Os teclados de trabalho atendem de ${percent}% dos pontos de condições ergonômicas, ou seja, acessórios em
    condições ergonômicas péssimas.`
  }

  if (percent >= 91 && type === 'mesas') {
    return `As mesas de trabalho atendem de ${percent}% dos pontos de condições ergonômicas, ou seja, postos em condições excelentes.`
  }
  if (percent >= 71 && type === 'mesas') {
    return `As mesas  de trabalho atendem de ${percent}% dos pontos de condições ergonômicas, ou seja, postos em condições boas.`
  }
  if (percent >= 51 && type === 'mesas') {
    return `As mesas  de trabalho atendem de ${percent}% dos pontos de condições ergonômicas, ou seja, postos em condições razoáveis.`
  }
  if (percent >= 31 && type === 'mesas') {
    return `As mesas  de trabalho atendem de ${percent}% dos pontos de condições ergonômicas, ou seja, postos em condições ruins.`
  }
  if (percent < 31 && type === 'mesas') {
    return `As mesas  de trabalho atendem de ${percent}% dos pontos de condições ergonômicas, ou seja, postos em condições péssimas.`
  }

  if (percent >= 91 && type === 'assentos') {
    return `Assentos de trabalho atendem de ${percent}% dos pontos em conformidade com a NR-17, item 17.6.6, ou seja, postos em condições ergonômicas excelentes.`
  }
  if (percent >= 71 && type === 'assentos') {
    return `Assentos de trabalho atendem de ${percent}% dos pontos em conformidade com a NR-17, item 17.6.6, ou seja, postos em condições ergonômicas boas.`
  }
  if (percent >= 51 && type === 'assentos') {
    return `Assentos de trabalho atendem de ${percent}% dos pontos em conformidade com a NR-17, item 17.6.6, ou seja, postos em condições ergonômicas razoáveis.`
  }
  if (percent >= 31 && type === 'assentos') {
    return `Assentos de trabalho atendem de ${percent}% dos pontos em conformidade com a NR-17, item 17.6.6, ou seja, postos em condições ergonômicas ruins.`
  }
  if (percent < 31 && type === 'assentos') {
    return `Assentos de trabalho atendem de ${percent}% dos pontos em conformidade com a NR-17, item 17.6.6, ou seja, postos em condições ergonômicas péssimas.`
  }
}

export const getSeatsReplies = (mainReply, remap) => {
  const furnitureReply = findReplyByQuestionName(mainReply.childrenReplies, 'Qual mobiliário?')
  const furnitureReplyValue = remap[furnitureReply.question.reference]

  const legalRequirements = findReplyByQuestionName(furnitureReplyValue, 'A. Requisitos Mínimos Legais')
  const a1 = getReplyFromMultipleChoice(legalRequirements.value, 'A.1 Altura ajustável (Item 17.6.6 a)')

  const ergonomicRequirements = findReplyByQuestionName(
    furnitureReplyValue,
    'B. Requisitos Ergonômicos de Boas Práticas'
  )
  const b5 = getReplyFromMultipleChoice(ergonomicRequirements.value, 'B.5 Cadeira possui braços?')
  const b6 = getReplyFromMultipleChoice(
    ergonomicRequirements.value,
    'B.6 Os braços das cadeiras são de altura regulável?'
  )
  const b7 = getReplyFromMultipleChoice(
    ergonomicRequirements.value,
    'B.7 Os braços das cadeiras possuem regulagem fácil ?'
  )
  const b9 = getReplyFromMultipleChoice(ergonomicRequirements.value, 'B.9 Há regulagem de altura de encosto?')
  const b13 = getReplyFromMultipleChoice(
    ergonomicRequirements.value,
    'B.13 Estofado encontra-se em perfeitas condições de uso ?'
  )

  return [
    {
      label: 'A. Requisitos Mínimos Legais',
      rows: [
        {
          label: 'A.1 Altura ajustável (Item 17.6.6 a)',
          value: a1 ? true : null,
          ignoreCount: false
        },
        {
          label: 'A.2 Base do acento com pouca ou nenhuma conformação? (Item 17.6.6 b)',
          value: true,
          ignoreCount: false
        },
        {
          label: 'A.3 Borda frontal arredondada (Item 17.6.6 d)',
          value: true,
          ignoreCount: false
        },
        {
          label: 'A.4 Encosto com forma levemente adaptada ao corpo para proteção da região lombar (item 17.6.6 e)',
          value: true,
          ignoreCount: false
        }
      ]
    },

    {
      label: 'B. Requisitos Ergonômicos de Boas Práticas',
      rows: [
        {
          label: 'B.1 Acionamento fácil da regulagem de altura',
          value: true,
          ignoreCount: false
        },
        {
          label: 'B.2 Largura da cadeira de dimensão correta?',
          value: true,
          ignoreCount: false
        },
        {
          label: 'B.3 Tecido da cadeira permite boa transpiração?',
          value: true,
          ignoreCount: false
        },
        {
          label: 'B.4 As rodas dos pés giram e rodam de forma adequada?',
          value: true,
          ignoreCount: false
        },
        {
          label: 'B.5 Cadeira possui braços?',
          value: !b5 ? false : b5.value === 'N/A' ? null : true,
          ignoreCount: true
        },
        {
          label: 'B.6 Os braços das cadeiras são de altura regulável?',
          value: !b6 ? false : b6.value === 'N/A' ? null : true,
          ignoreCount: true
        },
        {
          label: 'B.7 Os braços das cadeiras possuem regulagem fácil?',
          value: !b7 ? false : b7.value === 'N/A' ? null : true,
          ignoreCount: true
        },

        {
          label: 'B.8 Os braços da cadeira não prejudicam a aproximação do trabalhador até seu posto de trabalho?',
          value: true,
          ignoreCount: false
        },
        {
          label: 'B.9 Há regulagem de altura de encosto?',
          value: !b9 ? false : b9.value === 'N/A' ? null : true,
          ignoreCount: false
        },
        {
          label: 'B.10 Há regulagem de altura de encosto no sentindo anteroposterior?',
          value: true,
          ignoreCount: false
        },
        {
          label:
            'B.11 Por amostragem percebe-se que os mecanismos de regulagem de altura, de inclinação e da altura do apoio dorsal estão funcionando bem?',
          value: true,
          ignoreCount: false
        },
        {
          label: 'B.12 O usuário recebeu informações quanto à melhor forma de regulagem para a execução de sua tarefa?',
          value: true,
          ignoreCount: false
        },
        {
          label: 'B.13 Estofado encontra-se em perfeitas condições de uso?',
          value: !b13 ? false : b13.value === 'N/A' ? null : true,
          ignoreCount: false
        },
        {
          label: 'B.14 Havendo necessidade há apoio para pés durante a utilização deste tipo de assento?',
          value: true,
          ignoreCount: false
        }
      ]
    }
  ]
}

export const getTablesReplies = () => {
  return [
    {
      label: 'A. Requisitos Mínimos Legais',
      rows: [
        {
          label:
            'A.1 Possui altura e características da superfície de trabalho compatíveis com o tipo de atividade, com a distância requerida dos olhos ao campo de trabalho e com a altura do assento. (Item 17.6.3.b)',
          value: true,
          ignoreCount: false
        },
        {
          label: 'A.2 Possui área de trabalho de fácil alcance e visualização pelo trabalhador. (Item 17.6.3.c)',
          value: true,
          ignoreCount: false
        },
        {
          label:
            'A.3 Possui características dimensionais que possibilitem posicionamento e movimentação adequados dos segmentos corporais. (Item 17.6.3.a)',
          value: true,
          ignoreCount: false
        }
      ]
    },

    {
      label: 'B. Requisitos Ergonômicos de Boas Práticas',
      rows: [
        {
          label: 'B.1 Bordas arredondadas',
          value: true,
          ignoreCount: false
        },
        {
          label: 'B.2 O mobiliário está adequado para o trabalho?',
          value: true,
          ignoreCount: false
        },
        {
          label: 'B.3 Material não reflexivo? Cor adequada, para não refletir',
          value: true,
          ignoreCount: false
        },
        {
          label: 'B.4 Espaço para as pernas suficientemente profundo e largo',
          value: true,
          ignoreCount: false
        }
      ]
    }
  ]
}

export const getMeasurementResult = (tipo, valor) => {
  if (tipo === 'temperatura') {
    return valor >= 18 && valor <= 25 ? 'Adequada' : 'Inadequada'
  }

  if (tipo === 'ruido') {
    return valor <= 79 ? 'Adequada' : 'Inadequada'
  }

  if (tipo === 'umidade') {
    return valor >= 40 ? 'Adequada' : 'Inadequada'
  }

  if (tipo === 'iluminamento') {
    return valor >= 450 ? 'Adequada' : 'Inadequada'
  }
}

export const getRiskDescription = risco => {
  const map = {
    'ACIDENTES - BATIDA CONTRA': {
      nome: 'Batida contra',
      tipo: 'Acidentes',
      dano: 'Agência / Paredes, divisórias e outros utensílios',
      padroes: 'Qualitativa',
      fonte: 'Contato / Lesões pontuais e escoriações em casos mais graves torções e/ou fraturas ósseas.',
      epc: 'N/A',
      eficaz1: 'N/A',
      epi: 'N/A',
      ca: 'N/A',
      atenuacao: 'N/A',
      eficaz2: 'N/A',
      intensidade: 'Qualitativa',
      tecnica: 'Qualitativa'
    },
    'ACIDENTES - QUEDA DE MESMO NIVEL': {
      nome: 'Queda de mesmo nível',
      tipo: 'Acidentes',
      dano: 'Agência / Piso, depressões ou objetos',
      padroes: 'Qualitativa',
      fonte: 'Contato / Lesões pontuais e escoriações em casos mais graves torções e/ou fraturas ósseas.',
      epc: 'N/A',
      eficaz1: 'N/A',
      epi: 'N/A',
      ca: 'N/A',
      atenuacao: 'N/A',
      eficaz2: 'N/A',
      intensidade: 'Qualitativa',
      tecnica: 'Qualitativa'
    },
    'ACIDENTES - QUEDA DE DIFERENTE NÍVEL': {
      nome: 'Queda de diferente nível',
      tipo: 'Acidentes',
      dano: 'Agência / Escadas ou degraus',
      padroes: 'Qualitativa',
      fonte: 'Contato / Lesões pontuais e escoriações em casos mais graves torções e/ou fraturas ósseas.',
      epc: 'N/A',
      eficaz1: 'N/A',
      epi: 'N/A',
      ca: 'N/A',
      atenuacao: 'N/A',
      eficaz2: 'N/A',
      intensidade: 'Qualitativa',
      tecnica: 'Qualitativa'
    },
    'ACIDENTES - QUEDA FIAÇÃO APARENTE': {
      nome: 'Queda fiação aparente',
      tipo: 'Acidentes',
      dano: 'Agência / Fiação Aparente',
      padroes: 'Qualitativa',
      fonte: 'Contato / Lesões pontuais e escoriações em casos mais graves torções e/ou fraturas ósseas.',
      epc: 'N/A',
      eficaz1: 'N/A',
      epi: 'N/A',
      ca: 'N/A',
      atenuacao: 'N/A',
      eficaz2: 'N/A',
      intensidade: 'Qualitativa',
      tecnica: 'Qualitativa'
    }
  }

  return map[risco]
}

export const formatValidityMonth = date => {
  if (!date) {
    return 0
  }

  const momentDate = moment(date).utc()
  return momentDate.month()
}

export const revisionDate = date => {
  if (!date) {
    return 'xx/xx/xxxx'
  }
  return formatDate('DD/MM/YYYY', date)
}

export const getValidity = serviceOrder => {
  const { place } = serviceOrder
  const placeFieldValue = place.fieldValues.find(fieldValue => fieldValue.field.name === 'Vigência')
  if (!placeFieldValue || !placeFieldValue.value) {
    return serviceOrder.endDate
  }
  switch (placeFieldValue.value.trim().toLowerCase()) {
    case 'janeiro':
      return mountValidityDate(0)
    case 'fevereiro':
      return mountValidityDate(1)
    case 'março':
      return mountValidityDate(2)
    case 'abril':
      return mountValidityDate(3)
    case 'maio':
      return mountValidityDate(4)
    case 'junho':
      return mountValidityDate(5)
    case 'julho':
      return mountValidityDate(6)
    case 'agosto':
      return mountValidityDate(7)
    case 'setembro':
      return mountValidityDate(8)
    case 'outubro':
      return mountValidityDate(9)
    case 'novembro':
      return mountValidityDate(10)
    case 'dezembro':
      return mountValidityDate(11)
    default:
      return mountValidityDate(0)
  }
}

const mountValidityDate = month => {
  const date = moment().set('month', month)
  return date.endOf('month')
}

export const mountValidityDateRange = serviceOrder => {
  const date = getValidity(serviceOrder)
  return formatIssueDate(date)
}
